// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.7428 8.5C12.5282 9.45094 13 10.6704 13 12C13 13.3296 12.5282 14.5491 11.7428 15.5H16.5C18.433 15.5 20 13.933 20 12C20 10.067 18.433 8.5 16.5 8.5H11.7428ZM2 12C2 8.96243 4.46243 6.5 7.5 6.5H16.5C19.5376 6.5 22 8.96243 22 12C22 15.0376 19.5376 17.5 16.5 17.5H7.5C4.46243 17.5 2 15.0376 2 12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-component-switch-filled')
export default class ComponentSwitchFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-switch-filled',
    }
  }
}
